import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.title',
        defaultMessage: 'Please check your details again'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.message',
        defaultMessage:
            "We weren't able to run a soft credit check. Double {messageCheckDetailsLink} you've given the right name, address and date of birth, and try again. "
    },
    name: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.name',
        defaultMessage: 'Name'
    },
    address: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.address',
        defaultMessage: 'Address'
    },
    dob: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.dob',
        defaultMessage: 'Date of birth'
    },
    tryAgainMessage: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.tryAgainMessage',
        defaultMessage: 'And then try again.'
    },
    messageCheckDetailsLink: {
        id: '_.automatedLendingDecision.decisionError.incompleteCreditCheckError.messageCheckDetailsLink',
        defaultMessage: 'check'
    }
});
